<template>
  <!-- 商城侧边栏BEGIN -->
  <div id="sidebarBox" v-cloak>
    <div class="index-sidebar-box">
      <div class="sidebar-header">
        <a href="javascript:;" @click="sidebarHeaderClick">
          <img :src="topImgUrl" class="img-responsive" alt="">
        </a>
      </div>
      <div class="sidebar-body">
        <div class="sidebar-content" :class="{'sidebar-content-close': !isShowList}">
          <div class="sidebar-item-btn" v-for="(item, index) in itemList" :key="index">
            <img :src="item.img + '?x-oss-process=image/resize,w_160,m_lfit'" alt="item.title"
                 @click.stop="itemClick(item)">

            <!--                    {# 联系弹窗 #}-->
            <div class="item-pop-box" v-if="item.custom === 'contact'" v-show="isShowContact">
              <div class="chat-wrapper">
                <span class="iconfont icon-guanbi1" @click="isShowContact=false"></span>
                <ul>
                  <li>
                    <a href="javascript:void(0);"
                       @click="openQidiankefu">
                                        <span class="icon">
                                            <img
                                                src="https://www.dellemc-solution.com/eshop/image/cache/catalog/demo/chat/qq-img-20x20.png"
                                                class="img-responsive"></span>
                      <span>在线客服</span>
                    </a>
                    <section class="timeWra">
                      <i class="time" style="font-size: 14px;">工作日 08:30-17:30</i>
                    </section>
                  </li>

                  <li onclick="gioTrackAction('eshop400clickPC_allrightfloat_presale')">
                    <span class="icon iconfont icon-tel"></span>采购咨询专线
                    <i class="telNum">400-884-6610</i>
                    <section class="timeWra">
                      <i class="time" style="font-size: 14px;">工作日 08:30-17:30</i>
                    </section>
                  </li>
                  <li onclick="gioTrackAction('eshop400clickPC_allrightfloat_aftersales')">
                    <span class="icon iconfont icon-tel"></span>售后咨询专线

                    <i class="server-time">7*24小时客户支持</i>
                    <i class="telNum">400-886-8616</i>
                    <i class="telNum">400-886-8618</i>
                  </li>
                </ul>
              </div>
            </div>

            <!--                    {# 二维码弹窗 #}-->
            <div class="item-pop-box" v-if="item.custom === 'qrcode'" v-show="isShowQrCode">
              <div class="qrcode-card">
                <div class="qrcode-card">
                  <div class="gzh-qrcode">
                    <div class="qrcode-img">
                      <img src="@/assets/aside-nav/gzh_qrcode.png" alt="">
                    </div>
                    <div class="qrcode-text">
                      微信扫码关注戴尔企采网<br>
                      了解更多企采会员福利
                    </div>
                  </div>
                  <div class="xcx-qrcode">
                    <div class="qrcode-img">
                      <img src="https://www.dellemc-solution.com/eshop/catalog/view/theme/default/img/xcx.png?v=0.1" alt="">
                    </div>
                    <div class="qrcode-text">
                      扫码加入会员<br>
                      领取会员10大特权
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="sidebar-item-btn" v-if="!isListPage" @click="goList">
            <img src="https://www.dellemc-solution.com/files/campaign/20230323/641bbfc0baf8f.png?x-oss-process=image/resize,w_160,m_lfit" alt="item.title">
          </div>
        </div>
        <div class="sidebar-control">
          <span class="iconfont" :class="isShowList?'icon-pre_up':'icon-pre_down'" @click="toggleSidebar"></span>
        </div>
      </div>
      <div class="sidebar-to-top" @click="toTop" v-show="isShowToTop">
        <img src="https://www.dellemc-solution.com/eshop/catalog/view/theme/mobile/img/sidebar/zhiding-btn.png"
             class="img-responsive" alt="">
      </div>
        <div class="sidebar-to-IT">
            <a href="https://www.dellemc-solution.com/campaign/coupon/box?id=7" rel="noreferrer" target="_blank" onclick="gioTrackAction('eshopRNavigation_Coupon_Click')">
                <img src="https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/integral/fixed-coupon-box.png"
                     class="img-IT" alt="">
            </a>
            <a href="https://www.dellemc-solution.com/solutioncatalog/" rel="noreferrer" target="_blank" onclick="gioTrackAction('eshopeshopRNavigation_Download_Click')">
                <img src="https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/integral/fixed-download-file.png"
                     class="img-IT" alt="">
            </a>
        </div>
    </div>
  </div>
  <!-- 商城侧边栏END -->
</template>

<script>
export default {
  name: "sideBar",
  data() {
    return {
      // 顶部图片
      topImgUrl: '',
      // 功能列表
      itemList: [],
      // 列表是否展开
      isShowList: true,
      // 联系我们弹窗是否显示
      isShowContact: false,
      // 小程序二维码是否显示
      isShowQrCode: false,

      // 是否显示滚动到顶部按钮
      isShowToTop: false,

      // 是否是列表页
      isListPage: true
    };
  },

  mounted() {
    let _this = this;
    // 点击其他地方隐藏弹窗
    document.addEventListener('click', function (e) {
      _this.hideAllDialog();
    });

    // 滚动时隐藏弹窗
    window.addEventListener('scroll', function (e) {
      _this.hideAllDialog();

      // 如果不在页面顶部则显示滚动到顶部按钮
      _this.isShowToTop = document.documentElement.scrollTop !== 0;
    });

    this.getSidebarData();
  },
  beforeDestroy() {
    // 移除所有点击事件监听

    // document.removeEventListener("click", this.bodyCloseMenus);
  },
  watch: {
    '$route': 'getPath'
  },
  methods: {
    // 隐藏所有弹窗
    hideAllDialog: function () {
      this.isShowContact = false;
      this.isShowQrCode = false;
    },

    getPath(e) {
      // 判断是不是列表页 列表页没有返回列表页按钮
      this.isListPage = e.path === '/home';
    },

    // 获取侧边栏数据
    getSidebarData: function () {
      let _this = this;
      let info = {
        platform : 'try',
        type : 'pc'
      }
      common.getJson('/api/shop/sidebar', info, function (res) {
        console.log(res);
        _this.topImgUrl = res.data.img
        _this.itemList = res.data.items
      });
    },
    // 右侧浮窗Topkv
    sidebarHeaderClick: function () {
      gioTrackAction('eshophomepagefloaticonclick_topkv')
      window.open(this.solution_host + '/campaign/2023promotion');
    },

    // 点击
    itemClick: function (item) {
      switch (item.custom) {
        case 'url':
          if (item.tag) {
            gioTrackAction(item.tag);
          }
          common.gotoUrl(item.url);
          break;
        case 'contact':
          this.isShowQrCode = false;
          this.isShowContact = !this.isShowContact;
          break;
        case 'qrcode':
          this.isShowContact = false;
          this.isShowQrCode = !this.isShowQrCode;
          break;
        default:
          break;
      }
    },

    // 侧边栏显示和收起
    toggleSidebar: function () {
      this.isShowList = !this.isShowList;
      $('.sidebar-content').slideToggle();
    },

    // 滚动到顶部
    toTop: function () {
      $('html, body').animate({scrollTop: 0}, 'fast');
    },

    goList() {
      this.$router.push({
        path: '/'
      });
    }
  }


}
</script>

<style lang="scss" scoped>
.index-sidebar-box {
  zoom: .88;
  div {
    box-sizing: border-box;
  }

  $brand-blue: #285cd7;
  position: fixed;
  top: 50%;
  right: 2px;
  z-index: 100001;
  transform: translateY(-50%);

  .sidebar-header {
    width: 107px;
    margin-bottom: -1px;

    img {
      width: 100%;
    }
  }

  .sidebar-body {
    width: 90px;
    margin-left: 10px;
    color: #fff;
    text-align: center;
    box-sizing: border-box;
    background-color: #285cd7;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    .sidebar-content {
      padding: 5px 5px 0;

      .sidebar-item-btn {
        position: relative;
        margin-bottom: 5px;
        color: #fff;
        cursor: pointer;
        text-align: center;
        //background: url("../img/sidebar-btn-bg.png") no-repeat;
        //background-size: 100% 100%;
        img {
          width: 100%;
        }

        &:hover {
          img {
            opacity: 0.8;
          }
        }

        & > a {
          display: block;
          width: 100%;
          height: 100%;
          color: inherit;
        }
      }

      .item-pop-box {
        position: absolute;
        top: 50%;
        left: -15px;
        box-sizing: border-box;
        transform: translateX(-100%) translateY(-50%);
        text-align: center;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);

        &::before {
          position: absolute;
          top: 50%;
          right: -10px;
          border-left: 10px solid #fff;
          border-top: 10px solid #fff;
          border-right: 10px solid transparent;
          content: '';
          transform: translateY(-50%) rotate(20deg);
        }

        //联系我们弹窗
        .chat-wrapper {
          width: 203px;
          z-index: 998;
          right: 50px;

          html[dir="rtl"] & {
            right: auto;
            left: 50px;
          }

          .icon-guanbi1 {
            position: absolute;
            top: 5px;
            right: 5px;
            font-size: 20px;
            z-index: 999;
            font-family: 'fontawesome';
            color: #ddd;
            cursor: pointer;
          }

          .header {
            font-weight: bold;
            font-size: 18px;
            padding: 7px 0;
            margin: -14px -10px 20px;
            border-bottom: 1px solid #eee;
            color: $brand-blue;

            i {
              color: $brand-blue;
            }
          }

          .phone {
            font-size: 15px;
            margin-bottom: 10px;
            color: $brand-blue;
          }

          .btn-meiqia {
            margin-bottom: 20px;
            color: #fff;
            height: 30px;
            border-radius: 6px;
            background-color: #007aff;

            &:hover {
              background-color: darken(#007aff, 10%);
            }

            i {
              margin-right: 6px;
            }
          }

          ul {
            list-style: none;
            padding-left: 0;
            margin-bottom: 0;

            li {
              padding: 15px 0 15px 10px;
              border-bottom: 1px solid #e5e5e5;
              margin: 0 17px;
              line-height: 20px;
              color: #0076ce;
              font-size: 16px;
              text-align: left;

              a {
                color: #0076ce;
                display: block;
                //border-radius: 6px;
                overflow: hidden;
                //height: 30px;
                //font-size: 12px;
                position: relative;
                //border: 1px solid #ddd;
                transition: all .3s ease-out;


                //&:hover {
                //	border-color: $brand-blue;
                //}

                span {
                  display: inline-block;
                }
              }

              .iconfont, .icon {
                display: inline-block;
                margin-right: 12px;
                font-size: 20px;
                position: relative;
                top: 1px;
                color: #0076ce;
              }

              i.telNum {
                display: block;
                font-size: 18px;
                font-weight: bold;
                font-family: Arial;
                padding: 5px 0 0 34px;
              }

              .extension-num {
                padding-left: 34px;
                font-size: 16px;
                display: inline-block;
              }

              .server-time {
                padding-left: 34px;
                font-size: 14px;
                display: inline-block;
              }

              .timeWra {
                padding: 4px 0 0 33px;
                font-family: Arial;

                .time {
                  font-size: 14px;
                  font-style: normal;
                }
              }
            }
          }
        }

        // qrCode弹窗
        .qrcode-card {
          width: 420px;
          height: 232px;
          padding: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .xcx-qrcode, .gzh-qrcode{
            position: relative;
            width: 180px;
            height: 220px;
          }
          .xcx-qrcode{
            &::before{
              content: '';
              position: absolute;
              top: 8px;
              left: -9px;
              width: 1px;
              height: 76%;
              border-left: 1px dashed #ccc;
            }
          }
          .qrcode-img {
            width: 100%;
          }

          .qrcode-text {
            font-size: 12px;
            color: #a7947e;
          }
        }
      }
    }

    .sidebar-content-close {
      padding-top: 8px;

      .sidebar-control {
        border-top: 1px solid #1b45ca;
      }
    }
  }

  .sidebar-control {
    .iconfont {
      cursor: pointer;
      font-size: 20px;
    }
  }

  .sidebar-to-top {
    width: 75px;
    position: absolute;
    left: 17px;
    bottom: -19px;
    cursor: pointer;

    img {
      width: 100%;
    }
  }
  .sidebar-to-IT{
      z-index: -1;
      width: 121px;
      position: absolute;
      right: 10px;
      bottom: -110px;
      cursor: pointer;
      &:hover{
          .dialog-IT{
              display: block;
          }
      }
    .img-IT{
      width: 100%;
        margin-top: 10px;
    }
    .dialog-IT{
      display: none;
      position: absolute;
      top: 50%;
      left: -15px;
      box-sizing: border-box;
      transform: translateX(-100%) translateY(-50%);
      text-align: center;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
      &::before{
        position: absolute;
        top: 50%;
        right: -10px;
        border-left: 10px solid #fff;
        border-top: 10px solid #fff;
        border-right: 10px solid transparent;
        content: "";
        transform: translateY(-50%) rotate(20deg);
      }
      .dialog-IT-info{
        padding: 10px;
        .dialog-IT-img{
          display: block;
          width: 180px;
          height: auto;
        }
        .dialog-IT-text{
          font-size: 12px;
          color: #a7947e;
        }
      }
    }
  }
}
</style>
